import * as yup from 'yup';
import { validate as isUUID } from 'uuid';
import { SinglePhotoPresentationLayout } from '@shared/utils/photoPresentationLayout';

const cropInfoSchema = yup.object({
  unit: yup.string().oneOf(['percent']).required(),
  x: yup.number().required(),
  y: yup.number().required(),
  width: yup.number().required(),
  height: yup.number().required(),
});

const photoSchema = yup.object({
  id: yup
    .string()
    .required()
    .test('is-uuid', '', value => value !== undefined && isUUID(value)),
  height: yup.number().required(),
  width: yup.number().required(),
  url: yup.string().url().required(),
  cropInfo: cropInfoSchema.required(),
});

const headerColorsSchema = yup.object({
  nameAndNavFontColor: yup.string().notRequired(),
  nameAndNavBackgroundColor: yup.string().notRequired(),
  nameAndNavBackgroundColorEnabled: yup.boolean().notRequired(),
});

const headerLayoutDataJSONSchema = yup.object({
  $id: yup.string().url().required(),
  presentationLayout: yup.string().required(),
  colors: headerColorsSchema.notRequired(),
  photos: yup.array(photoSchema).required(),
});

const websiteDesignSettingsSchema = yup.object({
  colors: yup.object({
    artBackgroundColor: yup.string().required(),
    artFontColor: yup.string().required(),
    pageBackgroundColor: yup.string().required(),
    pageFontColor: yup.string().required(),
    linkAndButtonColor: yup.string().required(),
  }),
  fontPackName: yup.string().required(),
  pageTransparency: yup.boolean().required(),
  pageShadow: yup.boolean().required(),
  welcomePhotoPresentationLayout: yup.string().required(),
});

const headerLayoutSchema = yup.object({
  dataJSON: headerLayoutDataJSONSchema.required(),
  schemaURL: yup.string().url().required(),
  websiteLayout: yup.string().required(),
});

export const websiteDesignSchema = yup.object({
  template: yup.string().required(),
  theme: yup.string().required(),
  websiteDesignSettings: websiteDesignSettingsSchema.required(),
  headerLayout: headerLayoutSchema.required(),
});

// Need to make changes in marcom templates to make the property names consistent with the website design settings schema
export const websiteDesignSettingsQueryParamSchema = yup.object({
  colors: yup
    .object({
      linkAndButton: yup.string().required(),
      artBackground: yup.string().required(),
      artFont: yup.string().required(),
      pageBackground: yup.string().required(),
      pageFont: yup.string().required(),
    })
    .required(),
  pageTransparency: yup.boolean().required(),
  pageShadow: yup.boolean().required(),
  photoPresentationLayout: yup
    .string()
    .oneOf(['center', 'fullWidth', 'pageWidth'] as SinglePhotoPresentationLayout[])
    .notRequired(),
  fontPackName: yup.string().notRequired(),
  isBlankTemplate: yup.boolean().notRequired(),
});

export const isWebsiteDesignSettingsFromQueryParamValid = (decodedSettings: Record<string, unknown>): boolean => {
  return websiteDesignSettingsQueryParamSchema.isValidSync(decodedSettings);
};
